module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-aside"
  }, [_c('div', {
    staticClass: "g-crop-image-box"
  }, [_c('div', {
    staticClass: "g-crop-image-principal",
    on: {
      "touchstart": _vm.drag,
      "mousedown": _vm.drag
    }
  }, [_c('div', {
    staticClass: "image-wrap",
    style: ({
      width: _vm.width + 'px',
      height: _vm.height + 'px',
      left: _vm.left + 'px',
      top: _vm.top + 'px',
      backgroundImage: 'url(' + _vm.src + ')',
      cursor: _vm.isResize ? 'default' : 'move'
    })
  }, [_c('img', {
    ref: "crop-image",
    staticStyle: {
      "width": "0",
      "height": "0"
    },
    attrs: {
      "src": _vm.src
    }
  })]), _vm._v(" "), (!_vm.isResize) ? _c('div', {
    staticClass: "image-mask"
  }, [_c('div', {
    staticClass: "mask top",
    style: ({
      top: 0,
      height: _vm.cropCSS.top + 'px',
      left: 0,
      width: '100%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "mask bottom",
    style: ({
      bottom: 0,
      top: (_vm.cropCSS.top + _vm.cropCSS.height) + 'px',
      left: 0,
      width: '100%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "mask left",
    style: ({
      top: _vm.cropCSS.top + 'px',
      height: _vm.cropCSS.height + 'px',
      left: 0,
      width: _vm.cropCSS.left + 'px'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "mask right",
    style: ({
      top: _vm.cropCSS.top + 'px',
      height: _vm.cropCSS.height + 'px',
      left: (_vm.cropCSS.left + _vm.cropCSS.width) + 'px',
      right: 0
    })
  })]) : _vm._e(), _vm._v(" "), (!_vm.isResize) ? _c('div', {
    staticClass: "crop-box",
    style: ({
      top: _vm.cropCSS.top + 'px',
      left: _vm.cropCSS.left + 'px',
      height: _vm.cropCSS.height + 'px',
      width: _vm.cropCSS.width + 'px'
    })
  }, [_c('div', {
    staticClass: "reference-line v"
  }), _vm._v(" "), _c('div', {
    staticClass: "reference-line h"
  }), _vm._v(" "), _c('a', {
    staticClass: "g-resize",
    on: {
      "touchstart": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.resize.apply(null, arguments)
      },
      "mousedown": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.resize.apply(null, arguments)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.resize) ? _c('resize-bar', {
    ref: "resizeBar",
    on: {
      "resize": _vm.resizeImage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isRotate) ? _c('rotate-bar', {
    on: {
      "rotate": _vm.rotateImage
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-973a4f9c","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-core-image-upload/dist/crop.vue
// module id = 1602
// module chunks = 0